export default __webpack_public_path__ + "static/media/993.ec509f13.png";